const Z_INDEX = {
  CONTEXT_MENU: 1150,
  TOOLTIP: 1200,
  POPOVER: 1200,
};
const ANIMATION_PROPERY_NAME = 'opacity';
const DEFAULT_SHOW_DURATION_ANIMATION = 275;
const DEFAULT_HIDE_DURATION_ANIMATION = 250;
const DEFAULT_OFFSET = 8;
const ARROW_VERTICAL_OFFSET = 4;
const ARROW_HORIZONTAL_OFFSET = 6;
const STATIC_SIDES = {
  top: 'bottom',
  right: 'left',
  bottom: 'top',
  left: 'right',
};
const ROTATION_VALUES = {
  left: 270,
  bottom: 180,
  right: 90,
  top: 0,
};
const DEFAULT_SHOW_STYLES = {
  opacity: 1,
  visibility: 'visible',
};

export { ANIMATION_PROPERY_NAME as A, DEFAULT_SHOW_DURATION_ANIMATION as D, ROTATION_VALUES as R, STATIC_SIDES as S, Z_INDEX as Z, DEFAULT_HIDE_DURATION_ANIMATION as a, DEFAULT_SHOW_STYLES as b, ARROW_VERTICAL_OFFSET as c, ARROW_HORIZONTAL_OFFSET as d, DEFAULT_OFFSET as e };
